import IHelpUrlBuilderService from "./IHelpUrlBuilderService";
import { TRANSFER_DOC_VERSION } from "../constants";

export default class HelpUrlBuilderService implements IHelpUrlBuilderService {
    // full structure: http://docs.ipswitch.com/MOVEit/Transfer<Version>/Help/<UserType>/<Lang>/<TargetId>.htm
    // If changing this value be sure to also change it in /skels/utility.xslskel
    private readonly baseUrl = "http://docs.ipswitch.com/MOVEit/";
    // TODO: add user api service to dynamically fetch user type
    constructor(private readonly userType: string, private readonly languageCode: string) {}

    public getHelpUrl(targetId: string) {
        return `${this.baseUrl}Transfer${TRANSFER_DOC_VERSION}/Help/${this.userType}/${this.languageCode}/${targetId}.htm`;
    }
}
